import React, { FC } from 'react'

import { IconFindAndRingYourDeviceProps } from './IconFindAndRingYourDevice.types'
import * as Styled from './styles/IconFindAndRingYourDevice.style'

import { nonThemeableRules } from '../../ruleSet'

const IconFindAndRingYourDevice: FC<IconFindAndRingYourDeviceProps> = ({
  size = nonThemeableRules.defaultSize as number as IconFindAndRingYourDeviceProps['size'],
  isResponsive = false,
}: IconFindAndRingYourDeviceProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18.867 26.812a6.498 6.498 0 1 0 0-12.995 6.498 6.498 0 0 0 0 12.995Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M32.85 20.288c0 9.282-13.925 21.35-13.925 21.35S5 29.57 5 20.288A13.925 13.925 0 0 1 18.925 6.363'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M18.863 6.363a13.985 13.985 0 0 1 14 13.985v0'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M41.532 15.84a8.27 8.27 0 0 1 0 8.953m-4.68-7.638a5.273 5.273 0 0 1 0 6.32'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconFindAndRingYourDevice
